import type React from 'react';
import { createGlobalStyle } from 'styled-components';
import normalize from 'app/normalise.css';
import { useGymStructure } from 'app/providers/gym-structure';
import { GymStructure } from 'app/types/graphql';

import 'rc-slider/assets/index.css';

const GlobalStyle = createGlobalStyle<{ gymStructure?: GymStructure }>`
  ${normalize}
  
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    box-sizing: inherit;
  }
  html {
    font-size: 16px;

    ${({ theme: { media } }) => {
      return `
        ${media.xl(
          ({ scaleForHighRes }) => `
            font-size: ${scaleForHighRes('16px')};
            `,
        )}
      `;
    }}

  }
  @font-face {
    font-family: 'Brutal';
    src: url('/fonts/BrutalType-Light.otf') format('opentype');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Brutal';
    src: url('/fonts/BrutalType-Regular.otf') format('opentype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Brutal';
    src: url('/fonts/BrutalType-Medium.otf') format('opentype');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Brutal';
    src: url('/fonts/BrutalType-Bold.otf') format('opentype');
    font-weight: 700;
    font-style: normal;
  }
  body {
    box-sizing: border-box;
    font-family: 'Poppins', sans-serif;
    background: ${({ theme: { colors }, gymStructure }) => {
      if (gymStructure && gymStructure === GymStructure.HPC) {
        return `linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65)), url("hpc-bg.png") center / cover no-repeat black`;
      }
      return colors.black;
    }};
    color: ${({ theme: { colors } }) => colors.white};
  }
`;

// Dynamic Global Style Component that can access context
const DynamicGlobalStyle: React.FC = () => {
  const { gymStructure } = useGymStructure();

  return <GlobalStyle gymStructure={gymStructure} />;
};

export default DynamicGlobalStyle;
